<script setup>
import { teamLabel } from '~/lib/utils';

const user = useUser();

const options = computed(() => [
  { mode: 'park', label: 'Park', to: '/search' },
  { mode: 'lots', label: teamLabel(user.getRoles), to: '/dashboard' },
]);

const choose = (option) => {
  if (user.mode === option.mode) return;
  user.setMode(option.mode);
  navigateTo(option.to);
};
</script>

<template>
  <div v-if="user.hasTeamRole" class="inline-flex rounded-full bg-white/10 p-1" role="group" aria-label="Switch between parking and your team">
    <button
      v-for="option in options"
      :key="option.mode"
      type="button"
      :aria-pressed="user.mode === option.mode"
      :class="[
        'rounded-full px-3 py-1 text-xs font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-orange',
        user.mode === option.mode ? 'bg-white text-slate-950' : 'text-white hover:text-accent-orange'
      ]"
      @click="choose(option)"
    >
      {{ option.label }}
    </button>
  </div>
</template>
